import { mapMutations, mapActions } from 'vuex';

const highlightMixins = {
	data() {
		return {
			highlightedFiles: {},
			badgeText: 'All Highlighted',
			pyHighlightedFiles: {},
			// criticalHeaders: ['OPENING', 'PURCHASE', 'SALES', 'CLOSING'],
		};
	},
	methods: {
		...mapMutations(['openLoaderDialog', 'closeLoaderDialog']),
		...mapActions('fileExtraction', ['updateFlagForSelectedUUID']),

		async onHighlightAllFilesButtonClick(data, hightlightType = 'DEFAULT') {
			let listOfUUIDWithUnsucessfulApiCalls = [];
			this.openLoaderDialog();
			for (let file of data) {
				if (!file.isHighlighted || !file.isPYHighlighted) {
					let tempObj = {
						uuid: file.uuid,
						$set: {
							...(hightlightType === 'DEFAULT' && { isHighlighted: true }),
							...(hightlightType === 'PYHIGHLIGHT' && {
								isPYHighlighted: true,
							}),
						},
						$unset: {},
					};

					let updateFlagResult = await this.updateFlagForSelectedUUID(tempObj);
					if (!updateFlagResult.ok) {
						listOfUUIDWithUnsucessfulApiCalls.push(file.uuid);
					}
				}
			}
			this.closeLoaderDialog();
			this.refreshStockistList();
			if (listOfUUIDWithUnsucessfulApiCalls.length) {
				this.openSnackbar({
					text: 'Failed to highlight all Files, Please try again',
				});
			}
		},
		async onUnHighlightAllFilesButtonClick(data, hightlightType = 'DEFAULT') {
			console.log({ data, hightlightType });
			let listOfUUIDWithUnsucessfulApiCalls = [];
			this.openLoaderDialog();
			for (let file of data) {
				if (file.isHighlighted || file.isPYHighlighted) {
					let tempObj = {
						uuid: file.uuid,
						$set: {
							...(hightlightType === 'DEFAULT' && { isHighlighted: false }),
							...(hightlightType === 'PYHIGHLIGHT' && {
								isPYHighlighted: false,
							}),
						},
						$unset: {},
					};
					console.log(tempObj);

					let updateFlagResult = await this.updateFlagForSelectedUUID(tempObj);
					if (!updateFlagResult.ok) {
						listOfUUIDWithUnsucessfulApiCalls.push(file.uuid);
					}
				}
			}
			this.closeLoaderDialog();
			this.refreshStockistList();
			if (listOfUUIDWithUnsucessfulApiCalls.length) {
				this.openSnackbar({
					text: 'Failed to unhighlight all Files, Please try again',
				});
			}
		},
		createHighlightedFilesRefrenceList(data) {
			// console.log(data)
			for (let fileID of Object.keys(data)) {
				this.$set(this.highlightedFiles, fileID, {});
				this.$set(this.highlightedFiles[fileID], 'allHighlighted', false);
				this.$set(this.highlightedFiles[fileID], 'someHighlighted', false);

				this.$set(this.pyHighlightedFiles, fileID, {});
				this.$set(this.pyHighlightedFiles[fileID], 'allHighlighted', false);
				this.$set(this.pyHighlightedFiles[fileID], 'someHighlighted', false);

				const listOfHighlightedFiles = data[fileID].filter(
					e => e.isHighlighted
				);
				if (listOfHighlightedFiles.length) {
					if (listOfHighlightedFiles.length === data[fileID].length) {
						this.highlightedFiles[fileID].allHighlighted = true;
					} else {
						this.highlightedFiles[fileID].someHighlighted = true;
					}
				}

				const listOfPYHighlightedFiles = data[fileID].filter(
					e => e.isPYHighlighted
				);
				if (listOfPYHighlightedFiles.length) {
					if (listOfPYHighlightedFiles.length === data[fileID].length) {
						this.pyHighlightedFiles[fileID].allHighlighted = true;
					} else {
						this.pyHighlightedFiles[fileID].someHighlighted = true;
					}
				}
			}
		},
		onUnHighlightFileButtonClick(data, hightlightType = 'DEFAULT') {
			console.log(this.highlightedFiles);
			this.openLoaderDialog();
			let tempObj = {
				uuid: data.uuid,
				$set: {
					...(hightlightType === 'DEFAULT' && { isHighlighted: false }),
					...(hightlightType === 'PYHIGHLIGHT' && { isPYHighlighted: false }),
				},
				$unset: {},
			};
			// console.log({ tempObj });

			this.updateFlagForSelectedUUID(tempObj).then(data => {
				if (!data.ok) {
					this.openSnackbar({
						text: 'Failed to highlight the selected file, Please try again',
					});
				}

				this.closeLoaderDialog();
				this.refreshStockistList();
			});
		},
		onHighlightFileButtonClick(data, hightlightType = 'DEFAULT') {
			console.log(this.highlightedFiles);
			this.openLoaderDialog();
			let tempObj = {
				uuid: data.uuid,
				$set: {
					...(hightlightType === 'DEFAULT' && { isHighlighted: true }),
					...(hightlightType === 'PYHIGHLIGHT' && { isPYHighlighted: true }),
				},
				$unset: {},
			};
			// console.log({ tempObj });

			this.updateFlagForSelectedUUID(tempObj).then(data => {
				if (!data.ok) {
					this.openSnackbar({
						text: 'Failed to highlight the selected file, Please try again',
					});
				}

				this.closeLoaderDialog();
				this.refreshStockistList();
			});
		},
	},
};

export default highlightMixins;
